import * as React from 'react';
import { RouterLinks } from 'src/routing/routerLinks';
import { ClientPage } from '../Pages/ClientPage';
import { DashboardPageWithSidebar } from '../Pages/DashboardPage/DashboardPageWithSidebar';
import { LoggedInPage } from '../Pages/LoggedInPage';
import { PageWithUserContext } from '../Pages/PageWithUserContext';

export interface IDashboardLayoutProps extends React.PropsWithChildren {
  currentRoute: RouterLinks;
  isSpecificWorkOrderPage?: boolean;
}

export const DashboardLayout: React.FunctionComponent<
  IDashboardLayoutProps
> = props => {
  return (
    <ClientPage>
      <PageWithUserContext>
        <LoggedInPage>
          <DashboardPageWithSidebar currentRoute={props.currentRoute}>
            {props.children}
          </DashboardPageWithSidebar>
        </LoggedInPage>
      </PageWithUserContext>
    </ClientPage>
  );
};

export const getDashboardLayout = (currentRoute: RouterLinks) => {
  return function (page: React.ReactElement) {
    return (
      <DashboardLayout currentRoute={currentRoute}>{page}</DashboardLayout>
    );
  };
};
